import { Viewer } from '@oneclick/tangerine-viewer';
import { defaultConfig } from 'app/config/environment';
import { MAIN_CONTENT_ID } from 'core/layout/constants';
import PropTypes from 'prop-types';
import React from 'react';

const ViewerContainerFullScreen = ({
  showHeader,
  authToken,
  courseGuid,
  lang,
  user,
  contentGuid,
  pdfConfig,
  controllersConfig,
  pagesRangeShow,
  pdfLibrary,
  jobGuid,
  docConfig,
  reportErrorSentry,
  scormMetadata,
  goToBackViewer,
  externalContentUrl,
  onContentLoaded,
  onOpenExternal,
  contained,
}) => {
  return (
    <main className="viewer-v2 viewer-v2--full-screen" id={MAIN_CONTENT_ID} tabIndex={-1}>
      <Viewer
        authToken={authToken}
        contentGuid={contentGuid}
        controllersConfig={controllersConfig}
        courseGuid={courseGuid}
        domain={defaultConfig.BASE_URL_}
        lang={lang}
        pagesRangeShow={pagesRangeShow}
        pdfConfig={pdfConfig}
        scormMetadata={scormMetadata}
        showHeader={showHeader}
        pdfLibrary={pdfLibrary}
        user={user}
        jobGuid={jobGuid}
        docConfig={docConfig}
        reportErrorSentry={reportErrorSentry}
        onClose={goToBackViewer}
        externalContentUrl={externalContentUrl}
        onContentLoaded={onContentLoaded}
        onOpenExternal={onOpenExternal}
        contained={contained}
      />
    </main>
  );
};

ViewerContainerFullScreen.propTypes = {
  authToken: PropTypes.string.isRequired,
  contentGuid: PropTypes.string.isRequired,
  controllersConfig: PropTypes.object,
  courseGuid: PropTypes.string.isRequired,
  lang: PropTypes.string.isRequired,
  pagesRangeShow: PropTypes.array,
  pdfConfig: PropTypes.object,
  showHeader: PropTypes.bool,
  user: PropTypes.object.isRequired,
  pdfLibrary: PropTypes.string,
  jobGuid: PropTypes.string,
  docConfig: PropTypes.object,
  reportErrorSentry: PropTypes.func,
  scormMetadata: PropTypes.object,
  goToBackViewer: PropTypes.func,
  externalContentUrl: PropTypes.string,
  onContentLoaded: PropTypes.func,
  onOpenExternal: PropTypes.func,
  contained: PropTypes.bool,
};

ViewerContainerFullScreen.defaultProps = {
  showHeader: false,
  pdfLibrary: '',
  contained: false,
};

export default ViewerContainerFullScreen;
